import styled from 'styled-components';
import Logo from '../../../../new-components/ui/Logo';
import { useSelector } from 'react-redux';
import PriceInfo from './PriceInfo';

interface CompoundInfoProps {
  compoundName: string;
  developerLogo: string;
  developerSalePrice?: number;
  resalePrice?: number;
}
const CompoundInfo = ({
  compoundName,
  developerLogo,
  developerSalePrice,
  resalePrice
}: CompoundInfoProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container>
      <div className="compound-info">
        <h2>{compoundName}</h2>

        {isMobile && (
          <div className="developer-logo">
            <Logo logoPath={developerLogo} />
          </div>
        )}
      </div>

      {isMobile ? (
        <PriceInfo
          developerSalePrice={developerSalePrice!}
          resalePrice={resalePrice!}
        />
      ) : (
        <div className="developer-logo">
          <Logo logoPath={developerLogo} />
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #2c3138;

  .compound-info {
    display: flex;
    align-items: center;
    justify-content: center;

    h2 {
      font-family: materialBold;
      font-size: 18px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    span {
      font-size: 14px;
      font-family: materialRegular;
    }
  }

  .developer-logo {
    width: 48px;
    height: 48px;
    div {
      cursor: default;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    flex-direction: column;
    font-size: 21px;

    h2 {
      max-width: 95%;
    }

    .compound-info {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .developer-logo {
        width: 48px;
        height: 48px;
      }
    }
  }
`;

export default CompoundInfo;
